import { Col, Container, Row, Typography } from 'darrius';

import { ProCardDetail } from '../../../../../../components';

import { INSTANT_MATCH_V1_IS_ENABLED } from '../../../../../../utils/featureFlags/instantMatchV1';

import styles from './ExpressProsList.module.scss';

import { type TPro } from '../../../../../../modules/instantMatch/transformations';

interface IExpressProsListProps {
  pros: TPro[];
}

export function ExpressProsList({ pros }: IExpressProsListProps) {
  if (!pros.length) {
    return null;
  }

  function renderPro(pro: TPro, index: number) {
    const {
      id,
      link,
      name,
      photo,
      rating,
      isVerifiedPro,
      requestId,
      isInstitutionalPro,
      servicePrice,
    } = pro;

    if (INSTANT_MATCH_V1_IS_ENABLED && isInstitutionalPro) {
      return (
        <ProCardDetail.Institutional
          id={id}
          link={link}
          name={name}
          photo={photo}
          rating={rating}
          isVerifiedPro={isVerifiedPro}
          servicePrice={servicePrice}
          requestId={requestId}
        />
      );
    }

    return (
      <ProCardDetail.Default
        id={id}
        index={index}
        link={link}
        name={name}
        photo={photo}
        rating={rating}
        isVerifiedPro={isVerifiedPro}
        requestId={requestId}
      />
    );
  }

  return (
    <Container className={styles.container}>
      <div className={styles.header}>
        <Typography.Subtitle as="h5" size="l">
          Profissionais disponíveis para você
        </Typography.Subtitle>

        <Typography.Text as="p" className={styles.description}>
          Liberados pelo Atendimento Express. Toque em um profissional para ver
          o perfil completo e entrar em contato.
        </Typography.Text>
      </div>

      <Row className={styles.list}>
        <Col>
          {pros.map((pro, index) => (
            <Row className={styles.item} key={pro.id}>
              {renderPro(pro, index)}
            </Row>
          ))}
        </Col>
      </Row>
    </Container>
  );
}
